import { Component, effect, inject, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { TimeService } from '@vectronic/util';
import moment, { Moment } from 'moment';
import { FilterHeaderComponent } from '../filter-header/filter-header.component';
import { BaseFilterComponent } from '../filter/base-filter.component';

@Component({
  selector: 'vectronic-last-reception-filter',
  templateUrl: './vectronic-last-reception.component.html',
  styleUrls: ['./vectronic-last-reception.component.scss'],
  providers: [
    provideMomentDateAdapter({
      parse: {
        dateInput: 'YYYY-MM-DD',
      },
      display: {
        dateInput: 'YYYY-MM-DD',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
      },
    }),
  ],
  imports: [
    FilterHeaderComponent,
    MatSelectModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatInputModule,
  ],
})
export class VectronicLastReceptionComponent extends BaseFilterComponent {
  @ViewChild('selectInput', { read: MatSelect })
  matSelect: MatSelect;

  timeService = inject(TimeService);

  constructor() {
    super();
    // noinspection JSUnusedGlobalSymbols
    effect(() => {
      if (this.isFilterHidden()) setTimeout(() => this.matSelect.open());
    });
  }

  onDateChange({ value }: MatDatepickerInputEvent<Moment>) {
    this.filtersForm().get(this.utcFrom()).setValue(moment(value)?.utc?.(true).toISOString());
  }
}
